<template>
  <PgFilePreviewDialog
    :visible="value"
    @update:visible="updateVisible"
    :value="data"
    :current="item"
  />
</template>

<script setup>
import { PgFilePreviewDialog } from 'pangu-components-plus'

defineProps({
  // 是否弹出预览
  value: { type: Boolean, default: false },
  // 附件数据
  data: {
    type: Array,
    default() {
      return []
    },
  },
  // 当前点击的元素
  item: { type: Object },
})

const emit = defineEmits(['input'])

const updateVisible = (val) => {
  emit('input', val)
}
</script>
